// extracted by mini-css-extract-plugin
export default {"container":"FallbackProfileImage_container__kOlo8"};